import { useFormik } from "formik";
import SimpleButton from "global/SimpleButton/SimpleButton";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setOrder } from "redux/OrderData/OrderData";
import { addOrderData } from "redux/order-management-new";
import { addEditDataAPI } from "services/CRUDServices";

import OrderHeader from "../order-header";
import Receiver from "./receiver";

import { identityOrderFromValidation } from "global/Validation/Validation";
import { useGetMoreConsignmentInfo } from "pages/order-management-easy/hooks/useGetMoreConsignmentInfo";
import { useNavigate } from "react-router-dom";

interface IdentityOrderProps {
  setOpenForm?: (val: boolean) => void;
  editModalData?: any;
  setEditModalData?: any;
}

export default function IdentityOrderForm({
  setOpenForm,
  editModalData,
  setEditModalData,
}: IdentityOrderProps) {
  const dispatch = useDispatch();
  const { orderManagementData } = useSelector((state: any) => state.orderData);
  const { consignments } = useSelector((state: any) => state.Order);
  const { handleGetData } = useGetMoreConsignmentInfo();
  const [isAddAndNew, setIsAndAndNew] = useState(false);
  const navigate = useNavigate();
  const [freeBardoce, setFreeeBarcode] = useState({ data: "", loading: false });
  const formik = useFormik({
    enableReinitialize: true,
    validationSchema: identityOrderFromValidation,
    initialValues: editModalData
      ? {
          senderCustomerIdAuth: "0989330000121",
          consignmentId: editModalData?.id,
          consignmentType: { id: 3 },
          receiver: {
            name: editModalData?.receiver?.name,
            mobile: "0" + editModalData?.receiver?.mobile,
            receiverCityId: editModalData?.receiver?.receiverCityId,
            address: editModalData?.receiver?.address,
            passportCode: editModalData?.receiverDetails?.passportNumber,
            amayeshCode: editModalData?.receiverDetails?.amayeshCode,
            id: editModalData?.receiverDetails?.id,
          },

          cprNumber: editModalData?.cprNumber,
        }
      : {
          senderCustomerIdAuth: "0989330000121",
          receiver: {
            name: "",
            mobile: orderManagementData?.mobile,
            receiverCityId: orderManagementData?.receiverCityId,
            address: orderManagementData?.address,
            passportCode: "",
            amayeshCode: "",
          },
          cprNumber: "",
          consignmentType: { id: 3 },
        },

    validate: (values) => {
      const errors: any = {};

      const isValidCpr = String(values.cprNumber).length === 13 ? true : false;
      if (!isValidCpr) {
        errors.cprNumber = "شماره مرسوله باید 13 رقم باشد";
      }

      return errors;
    },
    onSubmit: (values, { setSubmitting }) => {
      setSubmitting(true);
      addEditDataAPI(
        editModalData
          ? "/consignment-api/consignmentCreateAuth/editOrderAndConsignment"
          : "/consignment-api/consignmentCreateAuth/createOrderAndConsignment",
        editModalData ? "put" : "post",
        {
          ...values,
          orderId: orderManagementData?.orderId,
          receiver: {
            ...values.receiver,
            receiverCityId: values.receiver?.receiverCityId?.id,
          },
        }
      )
        .then((res) => {
          setSubmitting(false);
          setFreeeBarcode({ data: "", loading: false });
          !isAddAndNew && setOpenForm && setOpenForm(false);
          setEditModalData && setEditModalData(null);
          const { id } = res.data?.payload;
          handleGetData(orderManagementData?.orderId || id, null, null, () => {
            navigate("/add-identity-order");
          });
          if (!orderManagementData?.orderId) {
            dispatch(
              addOrderData({
                ...values.sender,
                orderId: orderManagementData?.orderId || id,
                openModal: isAddAndNew,
                easyOrder: true,
                senderCustomerId:
                  process.env.NODE_ENV === "development" ? "253487" : "429685",
               ...values.receiver   
              })
            );

            dispatch(
              setOrder({
                orderId: orderManagementData?.orderId || id,

              })
            );

            setIsAndAndNew(false);
          }
          formik.setValues({
            ...formik.values,
            cprNumber: "",
            receiver: {
              ...formik.values.receiver,
              name: "",
              passportCode: "",
              amayeshCode: "",
            },
          });
        })
        .catch(() => {
          setSubmitting(false);
          setIsAndAndNew(false);
        });
    },
  });
  const { handleSubmit, setValues, isSubmitting } = formik;

  function submitAndNew() {
    if (!editModalData) {
      setIsAndAndNew(true);
      setTimeout(() => {
        handleSubmit();
      }, 200);
    } else {
      handleSubmit();
    }
  }

  function keyDown(e) {
    const code = e.keyCode;
    if (code === 120) {
      handleSubmit();
    } else if (code === 121) {
      submitAndNew();
    }
  }



  return (
    <form onSubmit={handleSubmit} onKeyDown={keyDown} tabIndex={0}>
      {consignments.length === 0 ? <OrderHeader formik={formik} /> : null}
      <div className="bg-lightGray rounded-2xl my-4 p-8 max-w-6xl shadow ">
        <Receiver
          formik={formik}
          submitAndNew={submitAndNew}
          freeBardoce={freeBardoce}
          setFreeeBarcode={setFreeeBarcode}
        />
        <div className="flex gap-6 justify-end">
          <SimpleButton
            type="submit"
            className="full-tomato-btn w-56 mt-6 mb-12"
            text={editModalData ? "ویرایش" : "ثبت و پرداخت"} //f9
            loading={isSubmitting}
          />
          {!editModalData && (
            <SimpleButton
              handelClick={submitAndNew}
              className="full-tomato-btn w-56 mt-6 mb-12"
              text="ثبت اعضا"
              loading={isSubmitting}
            />
          )}
        </div>
      </div>
    </form>
  );
}
